import { useMutation, ApolloError } from '@apollo/client'

import { MUTATION_UPDATE_USER } from '@libs/apollo/mutations'

import { User, UserUpdateInput, MutationUpdateUserArgs } from '@types'

interface Data {
  updateUser: User
}

export const useUpdateUser = (): {
  updateUser: (input: UserUpdateInput) => void
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [updateUser, { loading, error, data }] = useMutation<Data, MutationUpdateUserArgs>(MUTATION_UPDATE_USER, {
    notifyOnNetworkStatusChange: true,
  })

  const update = (input: UserUpdateInput) => {
    updateUser({ variables: { input } })
  }

  return { updateUser: update, loading, error, data }
}
